import { computed } from "vue";

import { getApiUrl } from "@Helpers/api/buildUrl";
import getStripePaymentLink from "@Helpers/api/getStripePaymentLink";
import { logError } from "@Helpers/logger";

import BILLABLE_TYPE from "@Constants/billable-type";

export default function useLatestPayment(billableType, currentBillable) {
  const latestPaymentApiUrl = computed(() => {
    if (billableType.value === BILLABLE_TYPE.ORGANIZATION) {
      const url = "organization/{organization}/subscription/payment/latest";
      const organization = currentBillable.value;

      return getApiUrl(url, { organization: organization.slug });
    }

    return getApiUrl("settings/subscription/payment/latest");
  });

  async function getLatestPaymentLink() {
    try {
      const { data } = await axios.get(latestPaymentApiUrl.value);

      return getStripePaymentLink(data.data.id);
    } catch (error) {
      logError("Unable to generate payment link: " + error.message);
    }
  }

  return {
    getLatestPaymentLink,
  };
}
